import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  deleteRecruitmentRequirementStart,
  deleteRecruitmentRequirementSuccess,
  deleteRecruitmentRequirementFailed,
} from "../redux/deleteRecruitmentRequirement";

import { deleteRecruitmentRequirementApi } from "core/http/service/recruitment";
import { resetControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import {
  getListRecruitmentRequirementStart,
  resetListRecruitmentRequirement,
} from "../redux/getListRecruitmentRequirement";
import { toast } from "react-toastify";

function* deleteRecruitmentRequirementWork(
  action: ReturnType<typeof deleteRecruitmentRequirementStart>
) {
  try {
    const res = yield call(deleteRecruitmentRequirementApi, action.payload);
    yield put({
      type: deleteRecruitmentRequirementSuccess.type,
      payload: {
        data: res.data,
      },
    });
    yield put({
      type: resetListRecruitmentRequirement.type,
    });
    yield put({
      type: resetControlPage.type,
      payload: "recruitmentRequirement",
    });
    yield put({
      type: getListRecruitmentRequirementStart.type,
    });
    toast.success("Xóa yêu cầu tuyển dụng thành công!");
  } catch (error: any) {
    yield put({
      type: deleteRecruitmentRequirementFailed.type,
    });
  }
}

function* watchDeleteRecruitmentRequirement() {
  yield takeLatest(
    deleteRecruitmentRequirementStart.type,
    deleteRecruitmentRequirementWork
  );
}

export default function* deleteRecruitmentRequirementSaga() {
  yield all([watchDeleteRecruitmentRequirement()]);
}
